<span *ngIf="(field?.touched || field?.dirty)" class="ss-form-validation__message" role="alert">
  <lucide-icon name="circle-alert" [size]="14" [strokeWidth]="2.4" aria-hidden="true"></lucide-icon>{{message}}
</span>
